export const topCardsPlansDetails = [
  {
    pack: 'Basic',
    amount: 'Free',
    currency: '',
    duration: '',
    planDesc: [
      'Data Tracking',
      'Reports & Graphs',
      'Scheduling',
      'Unlimited Students',
      'Service Time Tracking',
      'Mobile App',
    ],
    buttonStyle: 'no-border',
    ctaText: 'Start For Free',
    bestValueBanner: false,
    durationtype: '',
  },

  {
    pack: 'School/District/Enterprise',
    amount: 'Custom',
    currency: '',
    duration: '',
    planDesc: [
      'Admin Portal',
      'Staff and Admin Training',
      'Advanced Collaboration',
      'IEP System Integrations',
      'Single Sign On',
      'Dedicated Success Manager',
    ],
    buttonStyle: 'border',
    ctaText: 'Contact Us',
    bestValueBanner: false,
    durationtype: '',
  },
];

export const comparePlansDetails = [
  {
    title: 'Data Tracking',
    data: [
      {
        label: 'Unlimited Students',
        free: true,
        schools: true,
      },
      {
        label: 'Standard Goal Types',
        free: true,
        schools: true,
      },
      {
        label: 'Data Export',
        free: true,
        schools: true,
      },
      {
        label: 'Student Groups',
        free: false,
        schools: true,
      },
      {
        label: 'HIPAA/FERPA Compliance',
        free: true,
        schools: true,
      },
      {
        label: 'Custom Goal Type',
        free: false,
        schools: true,
      },
      {
        label: 'Goal Tags',
        free: false,
        schools: true,
      },
    ],
  },
  {
    title: 'Data Visualization',
    data: [
      {
        label: 'Auto Generated Graphs',
        free: true,
        schools: true,
      },
      {
        label: 'Automated Reports',
        free: true,
        schools: true,
      },
      {
        label: 'Archive Students',
        free: false,
        schools: true,
      },
      {
        label: 'Archive Goals',
        free: false,
        schools: true,
      },
      {
        label: 'Data Averages',
        free: false,
        schools: true,
      },
      {
        label: 'Reorder/Renumber Goals',
        free: false,
        schools: true,
      },
      {
        label: 'Student Filters in Reports',
        free: false,
        schools: true,
      },
      {
        label: 'Print Caseload',
        free: false,
        schools: true,
      },
      {
        label: 'Print Notes',
        free: false,
        schools: true,
      },
    ],
  },
  {
    title: 'Collaboration & Data Management',
    data: [
      {
        label: 'Collaboration with Paraprofessionals',
        free: 'Limited',
        schools: true,
      },
      {
        label: 'Transfer Students',
        free: false,
        schools: true,
      },
      {
        label: 'Bulk add students',
        free: false,
        schools: true,
      },
      {
        label: 'Bulk add goals',
        free: false,
        schools: true,
      },
      {
        label: 'Collaboration with Other Teachers/Therapists',
        free: false,
        schools: true,
      },
    ],
  },
  {
    title: 'Scheduling',
    data: [
      {
        label: 'Event Scheduling',
        free: true,
        schools: true,
      },
      {
        label: 'Multi Clinician Events',
        free: false,
        schools: true,
      },
      {
        label: "View/Edit Assistant's Calendar",
        free: false,
        schools: true,
      },
      {
        label: 'Print Student Schedule',
        free: false,
        schools: true,
      },
      {
        label: 'Mark Whole Day Absent',
        free: false,
        schools: true,
      },
    ],
  },
  {
    title: 'Management and Integrations',
    data: [
      {
        label: 'Admin Dashboard',
        free: false,
        schools: true,
      },
      {
        label: 'Staff and Admin Training',
        free: false,
        schools: true,
      },
      {
        label: 'IEP System Integration',
        free: false,
        schools: true,
      },
      {
        label: 'Single Sign On (SSO)',
        free: false,
        schools: true,
      },
      {
        label: 'Custom Features',
        free: false,
        schools: true,
      },
      {
        label: 'Priority Support',
        free: false,
        schools: true,
      },
      {
        label: 'Dedicated Success Manager',
        free: false,
        schools: true,
      },
    ],
  },
  {
    title: 'Other Features',
    data: [
      {
        label: 'Mobile App',
        free: true,
        schools: true,
      },
      {
        label: 'Service Time Tracking',
        free: true,
        schools: true,
      },
      {
        label: 'Medicaid Billing',
        free: false,
        schools: true,
      },
      {
        label: 'Assessments',
        free: false,
        schools: true,
      },
      {
        label: 'Materials Library',
        free: false,
        schools: true,
      },
    ],
  },
];
